import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DocumentorAI from "../pages/DocumentorAI";
import AInizedDocResults from "../pages/AInizedDocResults";
import NavBar from "../components/Navbar/Navbar";
import { useToken } from "../hooks/useToken";

export default function AppRoute() {
  const { token } = useToken();
  useEffect(() => {
    if(token) localStorage.setItem("token", token)
  }, [token]);
  return (
    <Router>
      <NavBar />
      <Routes>
        <Route path="/" element={<DocumentorAI />} />
        <Route path="/results" element={<AInizedDocResults />} />
      </Routes>
    </Router>
  );
}
